

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Article, ArticleForm } from '../services/articles';
import { articleService } from '../services';

@Component
export default class ArticleEdtior extends Vue {
  @Prop() slug!: string;
  form: ArticleForm = {
    title: '',
    description: '',
    body: '',
    tagList: []
  };
  tagInput: string = '';
  isLoading: boolean = false;

  async created() {
    if (this.slug !== undefined) {
      try {
        const { data } = await articleService.getArticle(this.slug);
        this.form = data.article;
      } catch (e) {
        alert(e);
      }
    }
  }

  async submit() {
    this.isLoading = true;
    try {
      if (this.slug !== undefined) {
        await articleService.updateArticle(this.slug, this.form);
      } else {
        await articleService.createArticle(this.form);
      }

      this.isLoading = false;
      this.$router.push({ name: 'home' });
    } catch (e) {
      alert(e);
      this.isLoading = false;
    }
  }

  addTag() {
    if (this.tagInput !== '') {
      this.form.tagList!.push(this.tagInput);
      this.tagInput = '';
    }
  }

  removeTag(tag: string) {
    this.form.tagList = this.form.tagList!.filter(t => t !== tag);
  }
}
